import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getRoles } from '../../../../redux/actions/admin';
import { getPlans } from '../../../../redux/actions/subscription';
import { getAllUsers, setUserState } from '../../../../redux/actions/user';

import UserTable from '../../../../components/Tables/UserTable';

const AdministrationUsers = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllUsers()).then(() => {
      dispatch(setUserState({ loading: false }));
    });
    dispatch(getPlans());
    dispatch(getRoles());
  }, [dispatch]);

  return <UserTable {...props} />;
};

export default AdministrationUsers;
